// extracted by mini-css-extract-plugin
export default {"Grid30p70pAnd30p30p30p":"Grid30p70pAnd30p30p30p_Grid30p70pAnd30p30p30p__f1hId"};